<div class="banner">
  <div>
    <strong>Welcome to the new home of Navy Cash! All navycash.com credentials are valid in the new EagleCash website.</strong><br>
    The EagleCash website now requires multi-factor
    authentication. Cardholder access will go through ID.me and all System Agents will need to authenticate with a CAC/PIV.
    <a routerLink="/help" fragment="_Toc202836376" class="helpLink">Read More</a>
  </div>
</div>
<div class="d-none d-md-block" style="padding-top: 100px;"></div>
<div id="login_page" class="justify-content-xs-center d-flex align-items-center justify-content-center">
  <img
    src="./assets/img/blueCard.png"
    alt="Card decoration left"
    class="login-side-card login-side-card-left"
    *ngIf="!isLoggedIn()"
  />

  <div class="login-box" *ngIf="!isLoggedIn()">
    <form
      id="login_form"
      name="loginForm"
      class="jumbotron form-horizontal ng-pristine"
      autocomplete="off"
      style="height: 356px"
    >
      <div id="combined_logo">
        <img
          src="./assets/img/eagleCashLargeLogoBlueAndGray.png"
          alt="login"
          class="centered image-responsive combined-logo-login"
        />
        <h4 class="logo-caption">Welcome to EagleCash</h4>
      </div>
      <fieldset class="login-fieldset">
        <div class="row zeroPadding">
          <div class=" col-sm-12" style="height: 102px">
            <button
              id="login_button"
              name="submitButton"
              class="btn btn-block loginButton"
              type="submit"
              value="Log In"
              [disabled]="false"
              (click)="login('cardholder')"
            >Cardholder Access
            </button>
          </div>
        </div>
        <div class="row zeroPadding">
          <div class=" col-sm-12" style="height: 101px">
            <button
              id="login_buttonTwo"
              name="submitButton"
              class="btn btn-block loginButton"
              type="submit"
              value="Log In"
              [disabled]="false"
              (click)="login('agent')"
            >System Agent Access
            </button>
          </div>
        </div>
      </fieldset>
    </form>
    <a
      id="military_seals"
      href="https://www.fiscal.treasury.gov/fsservices/gov/pmt/navyMarineCash/navyMarineCash_home.htm"
      title="Bureau of Fiscal Service"
      style="z-index: 1; position:relative;"
    ><img
      id="military_seals_img"
      src="assets/img/military_seals.png"
      class="centered image-responsive"
      alt="Military Seals Images"
    /></a>
  </div>

  <img
    src="./assets/img/Image_001.png"
    alt="Card decoration right"
    class="login-side-card login-side-card-right"
    *ngIf="!isLoggedIn()"
  />
</div>
